module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-introduction element-with-heading",
    attrs: {
      "id": "introduction"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("RENEGADE JUSTICE THRILLERS, FEATURING MORGAN AMES")])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-mixed"
  }, [_vm._v("Meet Everyone’s Favorite Teenage Psychopath…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "introduction-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Readers fell in love with Morgan in the Lucy Guardino thrillers and begged for more of everyone’s favorite teenaged psychopath…")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-large inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide block-height-not-mult-of-line-height inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('img', {
    attrs: {
      "alt": "Renegade Justice",
      "src": "images/morgan.jpg"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Morgan’s story begins in the second book of the Lucy Guardino thriller series, with Lucy’s husband, Nick, playing a significant role as Morgan tries to shun her serial-killer father’s indoctrination and give up violence.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To see how Morgan’s story fits in Lucy’s world, the stories in order are:")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("SNAKE SKIN")]), _vm._v(", Lucy Guardino FBI Thrillers Book #1")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("BLOOD STAINED")]), _vm._v(", introduces Morgan and Jenna")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("KILL ZONE")]), _vm._v(", features Morgan and Jenna, introduces Andre")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_vm._v("The Renegade Justice Thrillers")]), _vm._v(" (taking place in the year between KILL ZONE and AFTER SHOCK):")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/renegade-justice/",
      "target": "_blank"
    }
  }, [_vm._v("FIGHT DIRTY, Renegade Justice #1")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("RAW EDGES, Renegade Justice #2")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("ANGELS WEEP, Renegade Justice #3")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("LOOK AWAY, Renegade Justice #4")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("TRIP WIRE, Renegade Justice #5")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_vm._v("The Lucy Guardino Thrillers ")]), _vm._v("continue"), _c('b', [_vm._v(", ")]), _vm._v("chronicling Lucy’s departure from the FBI and her new adventures at Beacon Falls:")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("AFTER SHOCK")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("HARD FALL")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("BAD BREAK")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("LAST LIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("DEVIL SMOKE")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("OPEN GRAVE")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("GONE DARK")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("BITTER TRUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/lucy-guardino-fbi-thrillers/",
      "target": "_blank"
    }
  }, [_vm._v("LESSER EVIL")])]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break basic-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Want to be the first to have a chance to read the new books? Sign up for my "), _c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/signup",
      "target": "_blank"
    }
  }, [_vm._v("Thrillers with Heart newsletter HERE")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Be sure to open the Thrillers with Heart emails; they’ll arrive every few weeks with info on contests, new books, and exclusive offers for my readers!")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-freestanding inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide block-height-not-mult-of-line-height inline-image-without-caption inline-image-after-section-begin"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://cjlyons.net/signup",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Thanks for reading! CJ",
      "src": "images/image-300thanks-448.jpg"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b65957","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/renegade-justice-thrillers-featuring-morgan-ames.vue
// module id = 75
// module chunks = 0